import { useParams, useNavigate } from 'react-router-dom';
import useTabState from '../../hooks/useTabState';
import { TABS, Tab } from './constants';
import ExceptionsTab from './ExceptionsTab';
import ActivityLogTab from './ActivityLogTab';
import ByDepartmentTab from './ByDepartmentTab';
import ByEntityTab from './ByEntityTab';
import ExceptionDetail from './ExceptionDetail';
import PageLayout from '../../components/ui/PageLayout';
import TabBar from '../../components/ui/TabBar';

const TAB_ITEMS = TABS.map(t => ({ key: t, label: t }));

export default function ExceptionTracker() {
  const { exceptionId } = useParams<{ exceptionId?: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useTabState<Tab>('tab', TABS, 'Exceptions');

  // If URL has exceptionId, show detail view
  if (exceptionId) {
    return <ExceptionDetail id={Number(exceptionId)} onBack={() => navigate('/activity-tracker')} />;
  }

  return (
    <PageLayout
      title="Activity Tracker"
      subtitle="Monitor, investigate, and resolve exceptions across all departments"
    >
      <TabBar
        tabs={TAB_ITEMS}
        active={activeTab}
        onChange={(key) => setActiveTab(key as Tab)}
      />

      {activeTab === 'Exceptions' && <ExceptionsTab />}
      {activeTab === 'Activity Log' && <ActivityLogTab />}
      {activeTab === 'By Department' && <ByDepartmentTab />}
      {activeTab === 'By Entity' && <ByEntityTab />}
    </PageLayout>
  );
}
